import { REGISTER } from '../actions/types';

const initialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REGISTER.START:
      return {
        ...state,
        isLoading: true,
        data: null,
      };
    case REGISTER.ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: null,
        error: action.payload.response,
      };
    case REGISTER.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isSuccess: true,
        data: action.payload,
        error: null,
      };
    default:
      return state;
  }
};
